import React from "react";
import { Card } from "react-bootstrap";
import { FiChevronRight } from "react-icons/fi";

export default function QuickReminder() {
  return (
    <Card className="quick-card  mt-3 h-100">
      <Card.Body className="quick-body">

        {/* TEXT */}
        <div className="content">
          <p className="label">Quick Reminder</p>

          <h4 className="title">
            You have 21 Interview Schedule Today!
          </h4>

          <p className="desc">
            Dont forget to schedule interviews
          </p>

          {/* BUTTON */}
          <button className="schedule-btn mt-4">
            Schedule Now
            <span className="circle">
              <FiChevronRight />
            </span>
          </button>
        </div>

        {/* IMAGE */}
        <img
          src="/assets/img/bg/bg-05.png"
          alt=""
          className="bg-img"
        />

      </Card.Body>

      {/* ================= STYLES ================= */}
      <style>{`

        .quick-card {
           border-radius: 1px;
          border: 2px solid #e5e7eb;
          overflow: hidden;
        }

        .quick-body {
          position: relative;
          background: #154e5b;
          padding: 23px;
          min-height: 230px;
          display: flex;
          align-items: flex-start;
        }

        /* TEXT */
        .content {
          position: relative;
          z-index: 2;
          max-width: 70%;
        }

        .label {
          color: #cfd8dc;
          font-size: 14px;
          margin-bottom: 10px;
        }

        .title {
          color: #fff;
          font-weight: 600;
          font-size: 20px;
          margin-bottom: 10px;
          line-height: 1.4;
        }

        .desc {
          color: #d0e2e6;
          font-size: 14px;
          margin-bottom: 20px;
        }

        /* BUTTON EXACT */
        .schedule-btn {
          background: #ff6a00;
          color: white;
          border: none;
          padding: 9px 14px;
          border-radius: 30px;
          display: inline-flex;
          align-items: center;
          gap: 15px;
          font-weight: 500;
        }

        .schedule-btn .circle {
          width: 28px;
          height: 28px;
          background: white;
          color: black;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        /* IMAGE */
        .bg-img {
          position: absolute;
          right: 0;
          bottom: 0;
          width: 65%;
          object-fit: cover;
          opacity: 0.9;
        }

        /* ================= MOBILE ================= */
        @media (max-width: 768px) {

          .quick-body {
            padding: 20px;
            min-height: 200px;
          }

          .content {
            max-width: 100%;
          }

          .title {
            font-size: 18px;
          }

          .bg-img {
            width: 100%;
            opacity: 0.3;
          }
        }

      `}</style>
    </Card>
  );
}